/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* eslint-disable lines-between-class-members */
import _ from 'lodash';

const packageJSON = require('../../../package.json');

export class ToggleableFeature {
  static WS_NOTIFICATIONS = new ToggleableFeature('notification');
  static ADDRESS_BOOK = new ToggleableFeature('address-book');
  static USER_MANAGEMENT = new ToggleableFeature('user-management');
  static INVITATIONS_AUTOCOMPLETE = new ToggleableFeature('invitations-autocomplete');
  static FOOTER = new ToggleableFeature('footer');
  static HEADER = new ToggleableFeature('header');
  static PAYMENT = new ToggleableFeature('payment');
  static PAYMENT_PDF_DOWNLOAD = new ToggleableFeature('payment-pdf-download');

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

export const getPackageVersion = () => {
  const cleanedStr = packageJSON?.version.replace(/\./g, '');
  return parseInt(cleanedStr) || 0;
};

/* eslint no-new-wrappers: "off" */
export const isFeatureEnabled = (configuration, feature) => {
  const featureEnabled = _.get(configuration, `${feature}.enabled`);
  const minVersion = _.get(configuration, `${feature}.minVersion`);
  return (featureEnabled === 'true' || featureEnabled === true) && (!minVersion || getPackageVersion() >= minVersion);
};
